module.exports = __webpack_public_path__ + "img/_close_white.35e99e27.svg";